<template>
    <div class="FamilyServiceLog">
        <div class="row" style="margin-top:5px;">
            <div class="col-sm-3">
                <h2>Service Log <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /> <font-awesome-icon :icon="['fa', 'download']" v-on:click="DownloadData()" class="pointer" /></h2>
            </div>
            <div class="col-sm-3">
                <button type="button" class="btn btn-success" @click="OpenAddRecord()"><font-awesome-icon :icon="['fa', 'plus']" /> ADD NEW ENTRY</button>
            </div>
        </div>

        <form class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>From:</label>
                        <flat-pickr v-model="Filters.StartDateTime" class="form-control" :config="DateConfig"></flat-pickr>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>To:</label>
                        <flat-pickr v-model="Filters.EndDateTime" class="form-control" :config="DateConfig"></flat-pickr>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Entries:</label>
                        <input type="text" v-model="search" class="form-control" aria-label="Search" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4"></div>

            </div>
        </form>
        <vuetable :fields="Fields"
                  pagination-path=""
                  :api-mode="false"
                  class="vue-datatable"
                  :data-manager="DataManager"
                  ref="datatable"
                  id="servicelogentriestable"
                  track-by="Id">

            <template slot="EntryDateTime" scope="props">
                <div class="EntryDateTime">
                    <font-awesome-icon v-if="props.rowData.CanEdit && EditMode" :icon="['fa', 'edit']" @click="OpenEditRecord(props.rowData)" class="pointer" /><span>{{ formatEffectiveDateTime(props.rowData.EffectiveDateTime) }}</span>
                </div>
            </template>
            <template slot="EntryNotes" scope="props">
                <div class="EntryNotes">
                    <span v-html="props.rowData.Note"></span> <span v-if="props.rowData.DocumentID"><font-awesome-icon :icon="['fa', 'paperclip']" v-on:click="ViewDocument(props.rowData.DocumentPDFFileID, props.rowData.DocumentLabel, props.rowData.DocumentFileName)" class="pointer" /></span>
                </div>
            </template>
        </vuetable>

        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />

        <!--MODALS-->
        <b-modal ref="addedit-modal" :title="AddEditTitle" hide-footer>
            <b-container>
                <b-form @submit="AddUpdateEntry">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Date:</label>
                                <flat-pickr class="form-control" :config="DateConfig" v-model="TargetEntry.EffectiveDate" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Time:</label>
                                <flat-pickr class="form-control" :config="TimeConfig" v-model="TargetEntry.EffectiveTime"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Category:</label>
                                <select class="form-control" v-model="TargetEntry.Category" required>
                                    <optgroup v-for="optiongroup in Categories" :label="optiongroup.Label">
                                        <option v-for="option in optiongroup.Options" v-bind:value="option.value">
                                            {{ option.value }}
                                        </option>
                                    </optgroup>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Note:</label>
                                <textarea rows="6" class="form-control" v-model="TargetEntry.Note"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button v-if="AddEditTitle == 'Edit Entry'" size="md" variant="danger" @click="DeleteEntry()" style="float:left;">
                                DELETE
                            </b-button>
                            <b-button size="md" variant="secondary" @click="CancelAddEdit()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
    </div>
</template>

<script>
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../../services/event-bus.js';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
    library.add(faPaperclip);
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    import DocumentViewer from "../../../Core/RecordComponents/DocumentViewer.vue";

    export default {
        created() {
        },
        props: [
            "FamilyRecordData"
        ],
        data: function () {
            return {
                TargetEntry: {},
                EntrySchema: {
                    Id: "",
                    ChartID: "",
                    EffectiveDate: "",
                    EffectiveTime: "",
                    EffectiveDateTime: "",
                    Category: "",
                    Note: ""
                },
                AddEditTitle: "",
                NumberOfRecords: 0,
                search: "",
                Filters: {
                    StartDateTime: "",
                    EndDateTime: "",
                },
                EditMode: false,
                Fields: [
                    {
                        name: '__slot:EntryDateTime',
                        title: "Date/Time",
                        sortField: 'EffectiveDateTime',
                        dataClass: 'cell-no-wrap'
                    },
                    {
                        name: 'EffectiveDateTime',
                        title: "Date/Time",
                        sortField: 'EffectiveDateTime',
                        dataClass: 'cell-no-wrap',
                        callback: 'formatDate|MM/DD/YY',
                        visible: false,
                    },
                    {
                        name: 'Category',
                        title: 'Category',
                        sortField: 'Category',
                        dataClass: 'cell-no-wrap'
                    },
                    {
                        name: 'EmployeeAuthorName',
                        title: 'Author',
                        sortField: 'EmployeeAuthorName',
                        dataClass: 'cell-no-wrap'
                    },
                    {
                        name: '__slot:EntryNotes',
                        title: "Notes",
                        sortField: 'Note',
                    },
                    {
                        name: 'Note',
                        title: "Notes",
                        sortField: 'Note',
                        visible: false
                    }
                ],
                EntryData: [],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                TimeConfig: {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'h:i K'
                },
                Categories: [
                    {
                        Label: "Communication",
                        Options: [
                            {
                                value: "Communication With Family"
                            },
                            {
                                value: "Communication With Regulatory Agency"
                            },
                            {
                                value: "Communication With Other"
                            }
                        ]
                    },
                    {
                        Label: "Approval/Licensing Process",
                        Options: [
                            {
                                value: "Approval/Licensing Note"
                            }
                        ]
                    },
                    {
                        Label: "Referral Source",
                        Options: [
                            {
                                value: "Church"
                            },
                            {
                                value: "Friend"
                            },
                            {
                                value: "Internet Search"
                            },
                            {
                                value: "Send Conference"
                            },
                            {
                                value: "Social Media"
                            },
                        ]
                    },
                    {
                        Label: "Misc",
                        Options: [
                            {
                                value: "Incident"
                            },
                            {
                                value: "Informational"
                            },
                            {
                                value: "Other"
                            }
                        ]
                    }
                ]
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetEntries(true);
            },
            GetEntries(displayLoad = false) {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FamilyServiceLog/GetEntries", { FamilyID: this.FamilyRecordData.Family.Id, StartDateTime: this.Filters.StartDateTime, EndDateTime: this.Filters.EndDateTime }, this.GetEntriesSuccess, () => { }, displayLoad);
            },
            GetEntriesSuccess(response) {
                this.EntryData = response.data.data;
                this.$refs.datatable.refresh();
            },
            DownloadData(displayLoad = false) {
                this.$MasterAPI.ExecuteFileRequest("Foster/FamilyServiceLog/DownloadEntries", { FamilyID: this.FamilyRecordData.Family.Id, StartDateTime: this.Filters.StartDateTime, EndDateTime: this.Filters.EndDateTime });
            },
            formatEffectiveDateTime(value) {
                if (value.substring(11) == "00:00:00") {
                    return moment(value, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YY");
                } else {
                    return moment(value, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YY hh:mm A");
                }
            },
            OpenAddRecord() {
                this.AddEditTitle = "Add New Entry";
                this.TargetEntry = JSON.parse(JSON.stringify(this.EntrySchema));
                this.$refs['addedit-modal'].show();
            },
            OpenEditRecord(entryData) {
                if (this.EditMode && entryData.CanEdit) {
                    this.AddEditTitle = "Edit Entry";
                    this.TargetEntry = JSON.parse(JSON.stringify(entryData));
                    this.TargetEntry.EffectiveDate = moment(this.TargetEntry.EffectiveDateTime, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD");
                    this.TargetEntry.EffectiveTime = moment(this.TargetEntry.EffectiveDateTime, 'YYYY-MM-DD HH:mm:ss').format("HH:mm:ss");
                    this.$refs['addedit-modal'].show();
                }

            },
            CancelAddEdit() {
                this.$refs['addedit-modal'].hide();
            },
            AddUpdateEntry(e) {
                e.preventDefault();
                this.TargetEntry.ChartID = this.FamilyRecordData.Family.Id;
                this.TargetEntry.EffectiveDateTime = this.TargetEntry.EffectiveDate + " " + this.TargetEntry.EffectiveTime;
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FamilyServiceLog/AddUpdateEntry", this.TargetEntry, this.AddUpdateEntrySuccess, () => { }, true);
            },
            AddUpdateEntrySuccess(response) {
                this.GetEntries(true);
                this.$refs["addedit-modal"].hide();
            },
            DeleteEntry() {
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FamilyServiceLog/DeleteEntry", { Id: this.TargetEntry.Id }, this.DeleteEntrySuccess, () => { }, true);
            },
            DeleteEntrySuccess(response) {
                this.GetEntries(true);
                this.$refs["addedit-modal"].hide();
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.EntryData);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData;
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfRecords = visibleData.length;
                return visibleData;
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            Vuetable,
            flatPickr,
            EditMode,
            DocumentViewer
        },
        computed: {

        },
        mounted() {
            this.Filters.StartDateTime = moment().add(-90, "days").format("YYYY-MM-DD");
            this.Filters.EndDateTime = moment().format("YYYY-MM-DD");
            this.GetEntries();
            this.$refs.datatable.refresh();
        }
    }
</script>

<style scoped>
</style>